import {Component, Input, OnInit} from '@angular/core';
import {FormControlName, UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'app-number-decimal-field',
  templateUrl: './number-decimal-field.component.html',
  styleUrls: ['./number-decimal-field.component.scss'],
})
export class NumberDecimalFieldComponent implements OnInit {
  @Input() inputName: string;
  @Input() form: UntypedFormGroup;
  @Input() label: string;
  @Input() isError: boolean;
  @Input() placeholder: string;
  @Input() preValue: string;


  constructor() { }

  ngOnInit() {
    if (this.preValue && this.form && this.inputName) {
      this.form.get(this.inputName)?.setValue(this.preValue);
    }
  }

}
